import type { Pendencias } from 'service/api/endpoints/termos-politicas'

export const ROTA_ACEITE_TERMOS = '/termos-politicas/aceite'

const ROTAS_LIVRES = [
    ROTA_ACEITE_TERMOS,
    '/planos/checkout',
    '/termos',
    '/politicas',
    '/ajuda/atendimento-online',
]

function isNaRota(pathname: string, rota: string): boolean {
    return pathname === rota || pathname.startsWith(`${rota}/`)
}

interface Contexto {
    pendencias?: Pendencias
    pathname: string
}

/**
 * Diz se o dono do cliente deve ser preso na tela de aceite: há documento
 * pendente ou discordado. Ficam livres o checkout, que já colhe o aceite, a
 * leitura pública dos documentos e o atendimento online, para tirar dúvidas.
 */
export function isRedirecionarParaAceite({
    pendencias,
    pathname,
}: Contexto): boolean {
    if (!pendencias?.isDono) return false
    if (ROTAS_LIVRES.some(rota => isNaRota(pathname, rota))) return false
    return pendencias.documentos.some(it => it.status !== 'ACEITO')
}
